import { SelectItem } from "@mantine/core";

export const CLIENT_ROUTE = '/place';
export const API_ROUTE = '/api/place';
export const CLIENT_TITLE = 'Газрууд'

export type APIClient =
    '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    ;

interface PlayerOption extends Omit<SelectItem, 'value'> {
    value: APIClient;
}

export const players: PlayerOption[] = [
    { value: '1', label: 'A-100' },
    { value: '2', label: 'K-95' },
    { value: '3', label: 'VIVAUS' },
    { value: '4', label: 'HD' },
    { value: '5', label: 'S90' },
    { value: '6', label: 'S100' },
    { value: '7', label: 'S300' },
];